import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit, Close as IconClose } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";

import { ApiMasters } from "apihandlers//masters/masters";

import { NOTIFY, DEFAULTS, FORMATS, CONFIG, API_CONFIG } from "common/config";
import { COLORS } from "common/colors";
import { LABELS, ERRORS, WARNINGS, SUCCESS, TITLES } from "common/labels";

import { COMMON_JS } from "common/scripts";

import { DateFunctions } from "common/datefunctions";
import TxtBox from "components/Custom/TxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";
import { ApiIndents } from "apihandlers//indent";

const ApiMastersHandler = new ApiMasters();
const ApiIndentsHandler = new ApiIndents();

const thumbnailImg = require("assets/images/pdf.png");

const RepairForm = (props: any) => {
  const {
    defaultValues,
    setManageDialog,
    selectedRow,
    setSelectedRow,
    reloadGrid,
  } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [uploads, setUploads] = useState<any[]>([]);
  const [editRows, setEditRows] = useState<any[]>(null);
  const [repairFiles, setRepairFiles] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any>({});
  const [uploading, setUploading] = useState<boolean>(false);

  const vehicleTypeRef: any = useRef();

  useEffect(() => {
    if (loading) {
      getVehicles();
      if (selectedRow.id) {
        getUploadedFiles(selectedRow.id);
      }
    }
  }, [loading]);

  const getVehicles = () => {
    const args = {
      activeStatus: "true",
      shortMode: true,
    };
    ApiMastersHandler.getVehicles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.vehicleNumber,
          };
        });
        setVehicles(list);
      }
    });
  };

  const manageRecord = () => {
    const vehId = vehicleTypeRef.current.selectedValue.id;
    const workedOn = (
      document.getElementById("workedOn") as HTMLInputElement
    ).value.trim();
    let op = document.querySelector(
      'input[name="workType"]:checked'
    ) as HTMLInputElement;
    const workType = op ? op.value : "";
    const workPlace = (
      document.getElementById("workPlace") as HTMLInputElement
    ).value.trim();
    const workDescription = (
      document.getElementById("workDescription") as HTMLInputElement
    ).value.trim();
    const serialNo = (
      document.getElementById("serialNo") as HTMLInputElement
    ).value.trim();
    const odometerReading = (
      document.getElementById("odometerReading") as HTMLInputElement
    ).value.trim();
    const positionOfTyre = (
      document.getElementById("positionOfTyre") as HTMLInputElement
    ).value.trim();
    op = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = op ? op.value : "";

    // Validations

    let errors = [];
    if (!vehId) {
      errors.push({
        id: "vehId",
        msg:
          "<span class='bold'>" +
          LABELS.VEHICLE_NO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (workedOn == "") {
      errors.push({
        id: "workedOn",
        msg:
          "<span class='bold'>" +
          LABELS.WORK_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (workPlace == "") {
      errors.push({
        id: "workPlace",
        msg:
          "<span class='bold'>" +
          LABELS.WORK_LOCATION +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (workDescription == "") {
      errors.push({
        id: "workDescription",
        msg:
          "<span class='bold'>" +
          LABELS.DESCRIPTION +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (odometerReading == "") {
      errors.push({
        id: "odometerReading",
        msg:
          "<span class='bold'>" +
          LABELS.ODOMETER_READING +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!activeStatus) {
      errors.push({
        id: "activeStatus",
        msg:
          "<span class='bold'>" +
          LABELS.ACTIVE_STATUS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    const args = {
      id: selectedRow.id || -1,
      vehId,
      workType,
      workPlace,
      workDescription,
      activeStatus,
      workedOn,
      serialNo,
      odometerReading,
      positionOfTyre,
      files: repairFiles,
      // file: repairFiles.length > 0 ? repairFiles[0].id : -1,
    };

    console.log("Args", args);
    setIsSubmit(true);
    ApiMastersHandler.manageVehicleMaintenance(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const onUploadFile = (e: any, f: any) => {
    console.log("onUploadFile: ", e, f);
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      // setFuelFiles(null);
      setUploading(true);
      uploadFile(file, base64).then((res) => {
        // setFuelFiles([res]);
        setUploading(false);
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "repair",
    };
    let fileInfo = null;
    try {
      const res = await ApiIndentsHandler.fileUpload(args);
      console.log("uploadFile: ", args, res);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        setRepairFiles([...repairFiles, fileInfo]);
        (document.getElementById("uploadFile") as HTMLInputElement).value =
          null;
      }
    } catch (error) {}
    return fileInfo;
  };

  const getUploadedFiles = (maintenanceId) => {
    const args = {
      maintenanceId,
    };
    setUploading(true);
    setRepairFiles([]);
    ApiMastersHandler.getMaintenanceFileInfo(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        setRepairFiles(list);
        setUploading(false);
      }
    });
  };

  return (
    <UiDialog
      title={
        defaultValues.id
          ? "Add " +
            TITLES.REPAIR +
            " / " +
            TITLES.MAINTENANCE +
            " : " +
            defaultValues.vehicleNo
          : selectedRow.id
          ? "Edit  " +
            TITLES.REPAIRS +
            " / " +
            TITLES.MAINTENANCE +
            " :" +
            selectedRow.vehicleNumber
          : "Add " + TITLES.REPAIR + " / " + TITLES.MAINTENANCE
      }
      open={true}
      size={"sm"}
      onClose={() => {
        setSelectedRow({});
        setManageDialog(false);
      }}
    >
      <div className="flexColumn">
        <div className="formGroup red">
          <label>
            {LABELS.VEHICLE_NO}
            {<span>{" *"}</span>}
          </label>
          <AutoComplete
            list={vehicles}
            childRef={vehicleTypeRef}
            defaultValue={
              defaultValues.id
                ? {
                    id: defaultValues.vehicleId,
                    label: defaultValues.vehicleNo,
                  }
                : selectedRow.id
                ? {
                    id: selectedRow.vehId,
                    label: selectedRow.vehicleNumber,
                  }
                : null
            }
            onChange={(e, v) => {}}
            disabled={defaultValues.id || isSubmit}
          />
        </div>
        <div className="formGroup red">
          <TxtRow
            id={"workedOn"}
            label={LABELS.WORK_DATE}
            defaultValue={
              selectedRow.workedOn
                ? DateFunctions.getFormatedDate(
                    selectedRow.workedOn,
                    FORMATS.SQL_DATE,
                    FORMATS.SQL_DATE
                  )
                : DateFunctions.getDate("now", "from", FORMATS.SQL_DATE)
            }
            disabled={isSubmit}
            type={"datetime-local"}
            required={true}
          />
        </div>
        <div className="formGroup">
          <label>{LABELS.WORK_TYPE}</label>
          <RadioBtn
            name={"workType"}
            row={true}
            list={[
              {
                id: "0",
                label: LABELS.TYRE,
                value: LABELS.TYRE,
                checked: selectedRow.id
                  ? selectedRow.workType === "TYRE"
                  : true,
                disabled: false,
              },
              {
                id: "1",
                label: LABELS.ENGINE_OIL,
                value: LABELS.ENGINE_OIL,
                checked: selectedRow.id
                  ? selectedRow.workType === "ENGINE OIL"
                  : false,
                disabled: false,
              },
              {
                id: "2",
                label: LABELS.FILTERS,
                value: LABELS.FILTERS,
                checked: selectedRow.id
                  ? selectedRow.workType === "FILTERS"
                  : false,
                disabled: false,
              },
              {
                id: "3",
                label: LABELS.BELT,
                value: LABELS.BELT,
                checked: selectedRow.id
                  ? selectedRow.workType === "BELT"
                  : false,
                disabled: false,
              },
              {
                id: "4",
                label: LABELS.BEARING,
                value: LABELS.BEARING,
                checked: selectedRow.id
                  ? selectedRow.workType === "BEARING"
                  : false,
                disabled: false,
              },
              {
                id: "5",
                label: LABELS.ELECTRICAL,
                value: LABELS.ELECTRICAL,
                checked: selectedRow.id
                  ? selectedRow.workType === "ELECTRICAL"
                  : false,
                disabled: false,
              },
              {
                id: "6",
                label: LABELS.HOSES,
                value: LABELS.HOSES,
                checked: selectedRow.id
                  ? selectedRow.workType === "HOSES"
                  : false,
                disabled: false,
              },
              {
                id: "7",
                label: LABELS.FASTENERS,
                value: LABELS.FASTENERS,
                checked: selectedRow.id
                  ? selectedRow.workType === "FASTENERS"
                  : false,
                disabled: false,
              },
              {
                id: "8",
                label: LABELS.REEFER,
                value: LABELS.REEFER,
                checked: selectedRow.id
                  ? selectedRow.workType === "REEFER"
                  : false,
                disabled: false,
              },
              {
                id: "9",
                label: LABELS.PERIODIC,
                value: LABELS.PERIODIC,
                checked: selectedRow.id
                  ? selectedRow.workType === "PERIODIC"
                  : false,
                disabled: false,
              },
              {
                id: "10",
                label: LABELS.BREAKDOWN,
                value: LABELS.BREAKDOWN,
                checked: selectedRow.id
                  ? selectedRow.workType === "BREAKDOWN"
                  : false,
                disabled: false,
              },
              {
                id: "11",
                label: LABELS.OTHERS,
                value: LABELS.OTHERS,
                checked: selectedRow.id
                  ? selectedRow.workType === "OTHERS"
                  : false,
                disabled: false,
              },
            ]}
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup red">
          <TxtRow
            id={"workPlace"}
            label={LABELS.WORK_LOCATION}
            defaultValue={selectedRow.workPlace}
            disabled={isSubmit}
            required={true}
          />
        </div>

        <div className="formGroup red">
          <TxtRow
            id={"workDescription"}
            label={LABELS.DESCRIPTION}
            defaultValue={selectedRow.workDescription}
            disabled={isSubmit}
            required={true}
          />
        </div>

        <div className="formGroup ">
          <TxtRow
            id={"serialNo"}
            label={LABELS.SERIAL_NO}
            defaultValue={selectedRow.serialNo}
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup red">
          <TxtRow
            id={"odometerReading"}
            label={LABELS.ODOMETER_READING}
            defaultValue={selectedRow.odometerReading}
            disabled={isSubmit}
            required={true}
          />
        </div>

        <div className="formGroup">
          <TxtRow
            id={"positionOfTyre"}
            label={LABELS.POSITION_OF_TYRE}
            defaultValue={selectedRow.positionOfTyre}
            disabled={isSubmit}
          />
        </div>

        <div className="formGroup red">
          <label>
            {LABELS.ACTIVE_STATUS}
            {<span>{" *"}</span>}
          </label>
          <RadioBtn
            list={[
              {
                id: "vehicleActiveYes",
                value: "Yes",
                label: LABELS.ACTIVE,
                checked: selectedRow.id
                  ? selectedRow.activeStatus === "Yes"
                  : true,
                disabled: false,
              },
              {
                id: "vehicleActiveNo",
                value: "No",
                label: LABELS.INACTIVE,
                checked: selectedRow.id
                  ? selectedRow.activeStatus === "No"
                  : false,
                disabled: false,
              },
            ]}
            name={"activeStatus"}
            row={true}
            onChange={(e, v) => {}}
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup">
          <label>
            {LABELS.FILE_UPLOAD}
            <small>
              {" ( Max File Size: " + CONFIG.MAX_FILE_SIZE + " MB )"}
            </small>
          </label>
          <TxtBox
            type={"file"}
            id="uploadFile"
            className="uploadFile"
            accept="image/*,.pdf"
            onChange={onUploadFile}
          />
          <div
            className="formGroup"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
            }}
          >
            {repairFiles.map((u, i) => {
              return (
                <div className="thumbnailBox width20">
                  <IconButton
                    className="thumbnailBoxIcon"
                    onClick={() => {
                      const list = repairFiles.filter((a, j) => j !== i);
                      setRepairFiles(list);
                    }}
                  >
                    <IconClose />
                  </IconButton>
                  <img
                    onClick={() =>
                      window.open(API_CONFIG.API_URL + u.path, "_blank")
                    }
                    src={
                      u.mimeType === "pdf"
                        ? thumbnailImg
                        : API_CONFIG.STATIC_URL + u.path
                    }
                    className="responsive cursor"
                  />
                </div>
              );
            })}
            {uploading && (
              <div className="thumbnailBox width20">
                <SkeletonBox height={150} />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* mandatoryResults */}
      {mandatoryResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}

      <div className="formGroup submitBtnWrapper">
        <div className="flexbtnjustify">
          <Btn
            text={LABELS.CANCEL}
            bgColor={COLORS.RELOAD_EXPORT}
            color={COLORS.RELOAD_EXPORT_TEXT}
            onClick={() => {
              setSelectedRow({});
              setManageDialog(false);
            }}
            // loading={isSubmit}
          />
          <Btn
            text={LABELS.SAVE}
            onClick={manageRecord}
            loading={isSubmit}
            bgColor={COLORS.SAVE_GREEN}
          />
        </div>
      </div>
    </UiDialog>
  );
};
export default withSnackbar(RepairForm);
